import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    if (!localStorage.getItem("tiyeni_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("tiyeni_token");
      setUser(false);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const signIn = async (token) => { localStorage.setItem("tiyeni_token", token); await refresh(); };
  const signOut = () => { localStorage.removeItem("tiyeni_token"); setUser(false); };
  const can = (p) => !!user && user.permissions?.includes(p);
  const isStaff = !!user && user.permissions?.includes("view_staff");
  return <Ctx.Provider value={{ user, refresh, signIn, signOut, can, isStaff }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
